module.exports = __webpack_public_path__ + "static/media/painting.dd85898c.svg";